const RegistrationTypes = Object.freeze({
    VAULT_APP: 'VAULT_APP',
    VIMC: 'VIMC',
    VEEVAID: 'VEEVAID',
    NON_VAULT_APP: 'NON_VAULT_APP',
});

export default RegistrationTypes;
